import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useIsMobile } from "@/hooks/useIsMobile";
import { Info } from "@phosphor-icons/react/dist/ssr";
import { useState } from "react";

export default function CustomTooltip({ trigger, content }) {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  return isMobile ? (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>{trigger}</DrawerTrigger>
      <DrawerContent className='px-5 pb-5 bg-white text-background rounded-t-3xl'>
        <p className='pt-5 text-sm opacity-70'>{content}</p>
      </DrawerContent>
    </Drawer>
  ) : (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{trigger}</TooltipTrigger>
        <TooltipContent className='max-w-md text-xs font-normal bg-white border-none text-background'>
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
